export enum OperatorActionType {
	None = 0,
	Approve = 1,
	Request = 2,
	Reject = 3
}
